import { reduceAction } from '@elab/core/store/helpers';

import types from './types';

export const initialState = () => ({
    giftOptionData: {},
    metadata: {},
    selectedWrapEntries: [],
    appliedGiftOptions: [],
    checkoutBlocked: true,
    currentOptionApplied: false,
    showEmptyError: false,
    emptyMsgFeatureFlag: false,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.CHOOSE_PRODUCT_WRAP:
            return reduceAction(state, 'giftOptionData', action.payload);

        case types.SET_GIFT_OPTION_DATA:
            return reduceAction(state, 'giftOptionData', action.payload);

        case types.SET_PRODUCT_WRAP_METADATA:
            return reduceAction(state, 'metadata', action.payload);

        case types.SET_APPLIED_GIFT_OPTION:
            return {
                ...state,
                appliedGiftOptions: action.payload.appliedOptions,
                currentOptionApplied: action.payload.isCurrentOptionApplied,
            };

        case types.SET_SELECTED_PRODUCT_WRAP: {
            const { wrap, isEnabled } = action.payload;
            const uniqueEntriesForWrap = state.selectedWrapEntries.filter(
                item => item.productIdx !== wrap.productIdx && item.entryCode === wrap.entryCode,
            );
            const selectedEntryWrap = state.selectedWrapEntries.find(
                item => item.productIdx === wrap.productIdx && item.entryCode === wrap.entryCode,
            );

            const updatedWrapAccordingToProductQuantity =
                wrap.productIdx < state.giftOptionData.quantity ? { ...wrap } : null;

            const modifiedEntryWrap = {
                ...selectedEntryWrap,
                ...updatedWrapAccordingToProductQuantity,
            };
            return {
                ...state,
                selectedWrapEntries: wrap.data.code
                    ? [...uniqueEntriesForWrap, modifiedEntryWrap]
                    : [...uniqueEntriesForWrap],
                checkoutBlocked: !isEnabled,
            };
        }

        case types.UPDATE_WRAP_MESSAGE:
            return {
                ...state,
                selectedWrapEntries: state.selectedWrapEntries.map(item => {
                    if (item.productIdx === action.payload.productIdx) {
                        return { ...item, message: action.payload.message };
                    }
                    return item;
                }),
            };

        case types.UPDATE_APPLIED_OPTION_MESSAGE:
            return {
                ...state,
                appliedGiftOptions: state.appliedGiftOptions.map(item => {
                    if (item.giftOptionCode === action.payload.giftOptionCode) {
                        return { ...item, message: action.payload.message };
                    }
                    return item;
                }),
            };

        case types.CLEAN_SELECTED_WRAP_ENTRIES:
            return {
                ...state,
                selectedWrapEntries: [],
                appliedGiftOptions: [],
                giftOptionData: {},
                showEmptyError: false,
            };

        case types.SHOW_EMPTY_MSG_ERROR:
            return reduceAction(state, 'showEmptyError', action.payload);

        case types.UPDATE_EMPTY_MSG_FEATURE_FLAG:
            return reduceAction(state, 'emptyMsgFeatureFlag', action.payload);

        default:
            return state;
    }
};

export default reducers;
